module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_ny_lb4@2x.90d9f0a4.png";